<div class="ipo-page">
  <!-- Breadcrumb Navigation -->
  <div class="breadcrumb">
    <a routerLink="/">Home</a> 
    <span class="separator">></span> 
    <span class="current-page">Offer documents</span>
  </div>

  <!-- Tabs Navigation -->
  <div class="ipo-tabs">
    <a routerLink="/ipo" class="ipo-tab active">Offer documents</a>
    <!-- <a routerLink="/track-record" class="ipo-tab">Track Record</a> -->
  </div>

  <div class="ipo-grid">
    <!-- 3 Columns (Boxes) -->
    <div class="ipo-column" *ngFor="let group of columnGroups; let cIndex = index">
      <div class="ipo-sections">
        <div 
          class="ipo-card" 
          *ngFor="let card of group; let sIndex = index"
          [class.expanded]="expandedStates[cIndex + '_' + sIndex]"
        >
          <div class="ipo-card-header" (click)="toggleExpand(cIndex, sIndex)">
            <div class="header-left">
              <img [src]="card.icon" alt="icon" class="section-icon" />
              <h3 class="section-title">{{ card.title }}</h3>
            </div>
            <span class="toggle-icon">
              {{ expandedStates[cIndex + '_' + sIndex] ? '−' : '+' }}
            </span>
          </div>
          
          <div class="ipo-card-body" [class.open]="expandedStates[cIndex + '_' + sIndex]">
            <div class="ipo-card-content">
              <div class="ipo-items-container" *ngIf="card.items.length > 0">
                <ul class="ipo-items">
                  <li *ngFor="let item of card.items">
                    <a [attr.href]="item.url" target="_blank" rel="noopener noreferrer">{{ item.name }}</a>
                  </li>
                  <li>
                    <a>DRHP Audio Visuals</a>
                    <ul class="videos">
                      <li><a href="https://stalwartgroup.com/wp-content/uploads/2026/07/Stalwart-People-Services-India-IPO-AV-English.mp4"
                          target="_blank" rel="noopener noreferrer">English</a></li>
                      <li><a href="https://stalwartgroup.com/wp-content/uploads/2026/07/Stalwart-People-Services-India-IPO-AV-Hindi.mp4"
                          target="_blank" rel="noopener noreferrer">Hindi</a></li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
